import { specialCodeHead, specialCodeArr, appCodeMap } from "@/config/config";
import {
  getLocation,
  changeGPSLocation,
  geocoding,
  getNameByLocation,
} from "@/utils/locationUtils";
import Vue from "vue";
const env = process.env.VUE_APP_ENV;
// 匹配业务编码
// businessCodeStr=>业务编码 $@$@开头
// appCode=>应用编码  例如：dxlc_lz_app
async function businessCodeMatch(businessCodeStr, appCode) {
  console.log(businessCodeStr, appCode);
  // 如果在appCodeMap 找不到对应的应用编码
  if (!appCodeMap[appCode]) {
    console.log("在appCodeMap 找不到对应的应用编码");
    // 直接返回异常
    // 生成dom
    const DynamicComponent = Vue.extend({
      render(h) {
        return h(
          "div",
          {
            class: ["businessContent"],
          },
          [
            h(
              "div",
              {
                class: ["businessText"],
              },
              "服务配置有误，请联系平台客服"
            ),
          ]
        );
      },
    });
    return {
      status: "error",
      text: "服务配置有误，请联系平台客服",
      DynamicComponent,
    };
  }
  // 找到了应用编码
  else {
    // 接着匹配业务编码
    let specialCodeHeadLength = specialCodeHead.length;
    let specialCodeHead_current = businessCodeStr.substr(
      specialCodeHeadLength,
      3
    );
    console.log(specialCodeHead_current);
    // 如果未匹配到业务编码
    if (!appCodeMap[appCode][specialCodeHead_current]) {
      console.log("未匹配到业务编码");
      // 直接返回异常
      const DynamicComponent = Vue.extend({
        render(h) {
          return h(
            "div",
            {
              class: ["businessContent"],
            },
            [
              h(
                "div",
                {
                  class: ["businessText"],
                },
                "服务配置有误，请联系平台客服"
              ),
            ]
          );
        },
      });
      return {
        status: "error",
        text: "服务配置有误，请联系平台客服",
        DynamicComponent,
      };
    }
    // 匹配具体业务
    else {
      // 去乘车
      if (specialCodeHead_current == "000") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            clickShowQrCode() {
              this.showQrCode(123);
            },
            triggerBusiness: function () {
              this.clickShowQrCode();
            },
          },
        });
        return {
          status: "success",
          text: "去乘车",
          DynamicComponent,
        };
      }
      // 实时公交
      if (specialCodeHead_current == "001") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        console.log(businessDetail);
        // 直接跳实时公交首页 $@$@001
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看实时公交位置";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "realTimeBusUrl_" + env
            ];
          url =
            url +
            `#/AiPage?sessionId=${localStorage.getItem(
              "sessionId"
            )}&path=IndexPage`;
        } else if (businessDetail.length == 3) {
          // 跳站点详情 $@$@001_01_万象城
          if (businessDetail[1] == "01") {
            text = `点击下方链接，查看“${businessDetail[2]}”站点详情`;
            url =
              appCodeMap[appCode][specialCodeHead_current][
                "realTimeBusUrl_" + env
              ];
            url =
              url +
              `#/AiPage?sessionId=${localStorage.getItem(
                "sessionId"
              )}&path=StationDetailPage&stationName=${businessDetail[2]}`;
          }
          // 跳线路详情  $@$@001_02_110路
          if (businessDetail[1] == "02") {
            text = `点击下方链接，查看“${businessDetail[2]}”线路详情`;
            url =
              appCodeMap[appCode][specialCodeHead_current][
                "realTimeBusUrl_" + env
              ];
            url =
              url +
              `#/AiPage?sessionId=${localStorage.getItem(
                "sessionId"
              )}&path=LineDetailPage&lineName=${businessDetail[2]}`;
          }
          // 跳发车时刻表 $@$@001_03_110路
          if (businessDetail[1] == "03") {
            text = `点击下方链接，查看“${businessDetail[2]}”发车时刻表`;
            url =
              appCodeMap[appCode][specialCodeHead_current][
                "realTimeBusUrl_" + env
              ];
            url =
              url +
              `#/AiPage?sessionId=${localStorage.getItem(
                "sessionId"
              )}&path=TimetablePage&lineName=${businessDetail[2]}`;
          }
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          data: function () {
            return {
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "实时公交👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            clickShowQrCode() {
              this.showQrCode(123);
            },
            handleClick: function () {
              console.log(this.url);
              window.location.href = this.url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 智能出行
      if (specialCodeHead_current == "002") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 是否需要获取地理位置
        let needGetLocation = false;
        // 是否需要百度地图坐标转换
        let needChangeLocation = false;
        // 直接跳智能出行首页 $@$@002
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看行程规划";
          url = appCodeMap[appCode][specialCodeHead_current]["maasUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
        }
        // 跳智能出行 OD传参，我的位置-万象城 $@$@002_万象城
        else if (businessDetail.length == 2) {
          text = `点击下方链接，查看“我的位置-${businessDetail[1]}”行程规划`;
          url = appCodeMap[appCode][specialCodeHead_current]["maasUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          needGetLocation = true;
          needChangeLocation = true;
        }
        // 跳转智能出行，OD传参，万象城_新意城   $@$@002_万象城_新意城
        else if (businessDetail.length == 3) {
          text = `点击下方链接，查看“${businessDetail[1]}-${businessDetail[2]}”行程规划`;
          url = appCodeMap[appCode][specialCodeHead_current]["maasUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          needChangeLocation = true;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showLoading", "hideLoading", "showQrCode"],
          data: function () {
            return {
              needGetLocation,
              needChangeLocation,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "智能出行👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            clickShowQrCode() {
              this.showQrCode(123);
            },
            async handleClick() {
              //  如果是  我的位置-目的地
              // 先拿我的位置
              // 之后判断我的位置是不是在柳州市
              if (this.needGetLocation) {
                this.showLoading();
                let result = await getLocation();
                // 这里获取到的坐标是wgs84的
                console.log(result);
                if (
                  result &&
                  result.responseData &&
                  result.responseData.latitude &&
                  result.responseData.longitude
                ) {
                  // 把该位置转换成百度坐标系
                  let latitude = result.responseData.latitude;
                  let longitude = result.responseData.longitude;
                  console.log(latitude, longitude);
                  let baiduLocation = await changeGPSLocation(
                    longitude,
                    latitude
                  );
                  // 拿到了百度坐标
                  if (baiduLocation) {
                    // 305是柳州的城市编码  查一下我的位置的坐标是否在柳州市内
                    let result2 = await getNameByLocation(
                      baiduLocation.x,
                      baiduLocation.y,
                      305
                    );
                    // 如果我的坐标在柳州市内
                    if (result2) {
                      let departAddress = "我的位置";
                      let departAddressLng = baiduLocation.x;
                      let departAddressLat = baiduLocation.y;
                      // 再去地理编码第一个参数
                      let arriveData = await geocoding(
                        businessDetail[1],
                        "柳州市"
                      );
                      // 如果拿到了 到达地的位置
                      if (arriveData) {
                        let arriveAddress = businessDetail[1];
                        let arriveAddressLng = arriveData.location.lng;
                        let arriveAddressLat = arriveData.location.lat;
                        this.url =
                          url +
                          `&departAddress=${departAddress}&departAddressLng=${departAddressLng}&departAddressLat=${departAddressLat}&arriveAddress=${arriveAddress}&arriveAddressLng=${arriveAddressLng}&arriveAddressLat=${arriveAddressLat}`;
                        this.hideLoading();
                        console.log(this.url);
                        window.location.href = this.url;
                        return;
                      } else {
                        this.hideLoading();
                        console.log(this.url);
                        window.location.href = this.url;
                        return;
                      }
                    }
                    // 否则直接跳到maas首页
                    else {
                      this.hideLoading();
                      console.log(this.url);
                      window.location.href = this.url;
                      return;
                    }
                  } else {
                    this.hideLoading();
                    console.log(this.url);
                    window.location.href = this.url;
                    return;
                  }
                }
                // 未获取到自身位置
                else {
                  // 直接跳到首页即可
                  this.hideLoading();
                  console.log(this.url);
                  window.location.href = this.url;
                  return;
                }
              }
              // 否则是正常的OD
              else if (this.needChangeLocation) {
                let departData = await geocoding(businessDetail[1], "柳州市");
                let arriveData = await geocoding(businessDetail[2], "柳州市");
                if (departData && arriveData) {
                  let departAddress = businessDetail[1];
                  let departAddressLng = departData.location.lng;
                  let departAddressLat = departData.location.lat;
                  let arriveAddress = businessDetail[2];
                  let arriveAddressLng = arriveData.location.lng;
                  let arriveAddressLat = arriveData.location.lat;
                  this.url =
                    url +
                    `&departAddress=${departAddress}&departAddressLng=${departAddressLng}&departAddressLat=${departAddressLat}&arriveAddress=${arriveAddress}&arriveAddressLng=${arriveAddressLng}&arriveAddressLat=${arriveAddressLat}`;
                  // 直接跳到首页即可
                }

                this.hideLoading();
                console.log(this.url);
                window.location.href = this.url;
              } else {
                this.hideLoading();
                console.log(this.url);
                window.location.href = this.url;
              }
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 打车
      if (specialCodeHead_current == "003") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 是否需要获取地理位置
        let needGetLocation = false;
        // 是否需要百度地图坐标转换
        let needChangeLocation = false;
        // 直接跳打车首页 $@$@003
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看打车方案";
          url =
            appCodeMap[appCode][specialCodeHead_current]["takeTaxiUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
        }
        // 跳转聚合打车，OD传参，我的位置-万象城 $@$@003_万象城
        else if (businessDetail.length == 2) {
          text = `点击下方链接，查看“我的位置-${businessDetail[1]}”打车方案`;
          url =
            appCodeMap[appCode][specialCodeHead_current]["takeTaxiUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          needGetLocation = true;
          needChangeLocation = true;
        }
        // 跳转聚合打车，OD传参，万象城_新意城   $@$@003_万象城_新意城
        else if (businessDetail.length == 3) {
          text = `点击下方链接，查看“${businessDetail[1]}-${businessDetail[2]}”打车方案`;
          url =
            appCodeMap[appCode][specialCodeHead_current]["takeTaxiUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
          needChangeLocation = true;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showLoading", "hideLoading"],
          data: function () {
            return {
              needGetLocation,
              needChangeLocation,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "聚合打车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              if (this.needGetLocation) {
                this.showLoading();
                let result = await getLocation();
                // 这里获取到的坐标是wgs84的
                console.log(result);
                if (
                  result &&
                  result.responseData &&
                  result.responseData.latitude &&
                  result.responseData.longitude
                ) {
                  // 把该位置转换成百度坐标系
                  let latitude = result.responseData.latitude;
                  let longitude = result.responseData.longitude;
                  console.log(latitude, longitude);
                  let baiduLocation = await changeGPSLocation(
                    longitude,
                    latitude
                  );
                  // 拿到了百度坐标
                  if (baiduLocation) {
                    console.log(baiduLocation);
                    let departAddress = "我的位置";
                    let departAddressLng = baiduLocation.x;
                    let departAddressLat = baiduLocation.y;
                    // 再去地理编码第一个参数
                    let arriveData = await geocoding(
                      businessDetail[1],
                      "柳州市"
                    );
                    if (arriveData) {
                      let arriveAddress = businessDetail[1];
                      let arriveAddressLng = arriveData.location.lng;
                      let arriveAddressLat = arriveData.location.lat;
                      this.url =
                        url +
                        `&departAddress=${departAddress}&departAddressLng=${departAddressLng}&departAddressLat=${departAddressLat}&arriveAddress=${arriveAddress}&arriveAddressLng=${arriveAddressLng}&arriveAddressLat=${arriveAddressLat}`;
                    }
                    window.location.href = this.url;
                  }
                }
                // 未获取到自身位置
                else {
                  // 直接跳到首页即可
                  window.location.href = this.url;
                  return;
                }
                this.hideLoading();
              } else if (this.needChangeLocation) {
                let departData = await geocoding(businessDetail[1], "柳州市");
                let arriveData = await geocoding(businessDetail[2], "柳州市");
                if (departData && arriveData) {
                  let departAddress = businessDetail[1];
                  let departAddressLng = departData.location.lng;
                  let departAddressLat = departData.location.lat;
                  let arriveAddress = businessDetail[2];
                  let arriveAddressLng = arriveData.location.lng;
                  let arriveAddressLat = arriveData.location.lat;
                  this.url =
                    url +
                    `&departAddress=${departAddress}&departAddressLng=${departAddressLng}&departAddressLat=${departAddressLat}&arriveAddress=${arriveAddress}&arriveAddressLng=${arriveAddressLng}&arriveAddressLat=${arriveAddressLat}`;
                  // 直接跳到首页即可
                }
                window.location.href = this.url;
              } else {
                window.location.href = this.url;
              }
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 汽车票
      if (specialCodeHead_current == "004") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 直接跳汽车票首页 $@$@004
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看班次情况";
          url =
            appCodeMap[appCode][specialCodeHead_current]["coachBusUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}`;
        }
        // 跳转汽车票班次列表页面，OD传参，万象城_新意城   $@$@004_万象城_新意城
        else if (businessDetail.length == 3) {
          text = `点击下方链接，查看“${businessDetail[1]}-${businessDetail[2]}”班次情况`;
          url =
            appCodeMap[appCode][specialCodeHead_current]["coachBusUrl_" + env];
          url =
            url +
            `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&startAreaName=${businessDetail[1]}&stopAreaName=${
              businessDetail[2]
            }`;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          data: function () {
            return {
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "汽车票👉"
                ),
              ]
            );
          },
          methods: {
            clickShowQrCode() {
              this.showQrCode(123);
            },
            handleClick: function () {
              window.location.href = this.url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 火车票
      if (specialCodeHead_current == "005") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  "点击下方链接，去购票"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "火车票👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              // 如果是小程序
              if (window.__wxjs_environment) {
                let url = `/pages/JumpThirdWechatProgram/JumpThirdWechatProgram?url=${encodeURIComponent(
                  appCodeMap[appCode][specialCodeHead_current][
                    "trainUrl_" + env
                  ]
                )}`;
                wx.miniProgram.navigateTo({
                  url,
                });
              }
              // 否则是app环境
              else {
                let url =
                  appCodeMap[appCode][specialCodeHead_current][
                    "trainUrl_" + env
                  ];
                url +
                  `&thirdMemberId=${window.localStorage.getItem("appId_AI")}`;
                window.location.href = url;
              }
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text: "点击下方链接，去购票",
          DynamicComponent,
        };
      }
      // 机票
      if (specialCodeHead_current == "006") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  "点击下方链接，去购票"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "机票👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              // 如果是小程序
              if (window.__wxjs_environment) {
                let url = `/pages/JumpThirdWechatProgram/JumpThirdWechatProgram?url=${encodeURIComponent(
                  appCodeMap[appCode][specialCodeHead_current][
                    "airplaneUrl_" + env
                  ]
                )}`;
                wx.miniProgram.navigateTo({
                  url,
                });
              }
              // 否则是app环境
              else {
                let url =
                  appCodeMap[appCode][specialCodeHead_current][
                    "airplaneUrl_" + env
                  ];
                url =
                  url +
                  `&thirdMemberId=${window.localStorage.getItem("appId_AI")}`;
                window.location.href = url;
              }
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text: "点击下方链接，去购票",
          DynamicComponent,
        };
      }
      // 停车
      if (specialCodeHead_current == "007") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 直接跳停车首页 $@$@0007
        if (businessDetail.length == 1) {
          text = "点击下方链接，支付停车费用";
          url =
            appCodeMap[appCode][specialCodeHead_current]["parkCarUrl_" + env];
          url =
            url +
            `#/AiPage?sessionId=${window.localStorage.getItem("sessionId")}`;
        } else if (businessDetail.length == 2) {
          text = `点击下方链接，支付${businessDetail[1]}停车费用`;
          url =
            appCodeMap[appCode][specialCodeHead_current]["parkCarUrl_" + env];
          url =
            url +
            `#/AiPage?sessionId=${window.localStorage.getItem(
              "sessionId"
            )}&plateNumber=${businessDetail[1]}`;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          data: function () {
            return {
              text,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "停车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              console.log(this.url);
              window.location.href = this.url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 地铁路线
      if (specialCodeHead_current == "008") {
        let text = "点击下方链接，查看地铁路线图";
        let url =
          appCodeMap[appCode][specialCodeHead_current]["subwayLineUrl_" + env];
        url = url + `#/IndexPage`;
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          data: function () {
            return {
              text,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "地铁路线👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              window.location.href = this.url;
            },
            clickShowQrCode() {
              this.showQrCode(123);
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 列车位置
      if (specialCodeHead_current == "009") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 直接跳列车首页 $@$@009
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看列车位置";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayLocationUrl_" + env
            ];
          url = url + `#/TrainPositionPage2`;
        } else if (businessDetail.length == 2) {
          text = `点击下方链接，查看地铁${businessDetail[1]}列车位置`;
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayLocationUrl_" + env
            ];
          url =
            url +
            `#/AiPage?path=TrainStatusPage2&lineName=${businessDetail[1]}`;
        } else if (businessDetail.length == 3) {
          text = `点击下方链接，查看${businessDetail[1]}${businessDetail[2]}列车位置`;
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayLocationUrl_" + env
            ];
          url =
            url +
            `#/AiPage?path=TrainStatusPage&stationName=${businessDetail[2]}&lineName=${businessDetail[1]}`;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          data: function () {
            return {
              text,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "列车位置👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              window.location.href = this.url;
            },
            clickShowQrCode() {
              this.showQrCode(123);
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 地铁票价
      if (specialCodeHead_current == "010") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 直接跳地铁票价首页 $@$@010
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看地铁乘车费用";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayPriceUrl_" + env
            ];
          url = url + `#/FaresPage`;
        } else if (businessDetail.length == 3) {
          text = `点击下方链接，查看地铁${businessDetail[1]}—${businessDetail[2]}乘车费用`;
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayPriceUrl_" + env
            ];
          url =
            url +
            `#/AiPage?path=FaresPage&startStationName=${businessDetail[1]}&endStationName=${businessDetail[2]}`;
        }
        // 未匹配 跳到首页
        else {
          text = "点击下方链接，查看地铁乘车费用";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayPriceUrl_" + env
            ];
          url = url + `#/FaresPage`;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          data: function () {
            return {
              text,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "地铁票价👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              window.location.href = this.url;
            },
            clickShowQrCode() {
              this.showQrCode(123);
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 地铁首末班
      if (specialCodeHead_current == "011") {
        // 细分业务类型
        let businessDetail = businessCodeStr.split("_");
        let text = "";
        let url = "";
        // 直接跳地铁首末班 $@$@011
        if (businessDetail.length == 1) {
          text = "点击下方链接，查看地铁首末班";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayTimeTableUrl_" + env
            ];
          url = url + `#/DepartListPage`;
        } else if (businessDetail.length == 3) {
          text = `点击下方链接，查看地铁${businessDetail[1]}${businessDetail[2]}首末班`;
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayTimeTableUrl_" + env
            ];
          url =
            url + `#/AiPage?path=DepartListPage&lineName=${businessDetail[1]}`;
        }
        // 未匹配 跳到首页
        else {
          text = "点击下方链接，查看地铁首末班";
          url =
            appCodeMap[appCode][specialCodeHead_current][
              "subwayTimeTableUrl_" + env
            ];
          url = url + `#/DepartListPage`;
        }
        // 生成dom
        const DynamicComponent = Vue.extend({
          props: ["showQrCode"],
          data: function () {
            return {
              text,
              url,
            };
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  text
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "地铁首末班👉"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.clickShowQrCode,
                    },
                  },
                  "去乘车👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              window.location.href = this.url;
            },
            clickShowQrCode() {
              this.showQrCode(123);
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text,
          DynamicComponent,
        };
      }
      // 权益中心
      if (specialCodeHead_current == "012") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          data: function () {
            return {};
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  "点击下方链接"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "权益中心👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              let url =
                appCodeMap[appCode][specialCodeHead_current][
                  "equityCenterUrl_" + env
                ];
              console.log(appCode, specialCodeHead_current, env, url);
              url =
                url +
                `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
                  "sessionId"
                )}&target=IndexPage`;
              window.location.href = url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text: "点击下方链接",
          DynamicComponent,
        };
      }
      // 积分商城
      if (specialCodeHead_current == "013") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          data: function () {
            return {};
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  "点击下方链接"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "积分商城👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              let url =
                appCodeMap[appCode][specialCodeHead_current][
                  "pointMallUrl_" + env
                ];
              url =
                url +
                `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
                  "sessionId"
                )}&target=PointMallPage`;
              window.location.href = url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text: "点击下方链接",
          DynamicComponent,
        };
      }
      // 付费会员
      if (specialCodeHead_current == "014") {
        // 生成dom
        const DynamicComponent = Vue.extend({
          data: function () {
            return {};
          },
          render(h) {
            return h(
              "div",
              {
                class: ["businessContent"],
              },
              [
                h(
                  "div",
                  {
                    class: ["businessText"],
                  },
                  "点击下方链接"
                ),
                h(
                  "div",
                  {
                    class: ["tagA"],
                    on: {
                      click: this.handleClick,
                    },
                  },
                  "会员详情👉"
                ),
              ]
            );
          },
          methods: {
            async handleClick() {
              let url =
                appCodeMap[appCode][specialCodeHead_current]["vipUrl_" + env];
              url =
                url +
                `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
                  "sessionId"
                )}&target=VipDetailPage`;
              window.location.href = url;
            },
            triggerBusiness: function () {
              this.handleClick();
            },
          },
        });
        return {
          status: "success",
          text: "点击下方链接",
          DynamicComponent,
        };
      }
    }
  }
}

export { businessCodeMatch };
